'use strict';

import validator from '../validator';

/**
 * @private
 * @function
 * @description Validates if check order form is filled out before enabling button
 */
function initializeEvents() {
    validator.initForm('form[id$="ordertrack"]');
}

export default {
    init: function () {
        initializeEvents();
    }
}
